import { Converter } from "../../interface/converter.interface";

	/**
	 * @description
	 *	Permite transformar un número en formato ZZZAA que codifica una zona
	 *	ZZZ junto con un área AA, en un número que solo contiene al área.
	 */

export class AreaWithoutZoneConverter implements Converter<number, number> {

	constructor() {}

	public preConvert(value: number): number {
		return value;
	}

	public postConvert(value: number): number {
		return parseInt(`${value}`.substring(3));
	}
}
